import { useState, useEffect } from 'react';
import { COUNTRY_COORDS } from './ClockWeather';

function getLocalHour(tz) {
  try {
    const s = new Date().toLocaleString('en-US', { timeZone: tz, hour: '2-digit', hour12: false });
    return parseInt(s, 10) % 24;
  } catch {
    return new Date().getHours();
  }
}

function applyFilter(b, w) {
  const sepia = w > 0 ? ` sepia(${w}%)` : '';
  document.documentElement.style.filter = `brightness(${b}%)${sepia}`;
}

export default function NightVisionEngine() {
  const [mode, setMode] = useState(() => localStorage.getItem('nv_mode') || 'off');
  const [country, setCountry] = useState(() => localStorage.getItem('nv_country') || 'IN');
  const [brightness, setBrightness] = useState(() => +(localStorage.getItem('nv_brightness') || 100));
  const [warmth, setWarmth] = useState(() => +(localStorage.getItem('nv_warmth') || 0));

  useEffect(() => {
    const onModeChange = () => {
      setMode(localStorage.getItem('nv_mode') || 'off');
      setBrightness(+(localStorage.getItem('nv_brightness') || 100));
      setWarmth(+(localStorage.getItem('nv_warmth') || 0));
    };
    const onCountryChange = () => setCountry(localStorage.getItem('nv_country') || 'IN');
    window.addEventListener('cu_mode_changed', onModeChange);
    window.addEventListener('cu_country_changed', onCountryChange);
    return () => {
      window.removeEventListener('cu_mode_changed', onModeChange);
      window.removeEventListener('cu_country_changed', onCountryChange);
    };
  }, []);

  useEffect(() => {
    if (mode === 'off') {
      document.documentElement.style.filter = '';
      return;
    }
    if (mode === 'manual') {
      applyFilter(brightness, warmth);
      return;
    }
    if (mode === 'auto') {
      const tz = COUNTRY_COORDS[country]?.tz || 'Asia/Kolkata';
      const check = () => {
        const hour = getLocalHour(tz);
        const isNight = hour >= 20 || hour < 6;
        if (isNight) applyFilter(65, 25);
        else applyFilter(100, 0);
      };
      check();
      const interval = setInterval(check, 60000);
      return () => clearInterval(interval);
    }
  }, [mode, country, brightness, warmth]);

  return null;
}
